import { kciEnTranslations } from './kci.en';
import { kciHeTranslations } from './kci.he';

export const kciTranslations = {
  en: kciEnTranslations,
  he: kciHeTranslations,
} as const;
